var _path, _path2, _path3, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoubleForm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Vrstva_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 85 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "SI_4L_stroke",
    d: "M46 25.7H36M46.1 31H36M35 11.1h12.3c2.6 0 4.6 2.1 4.6 4.6v17.1c0 2.6-2.1 4.6-4.6 4.6H35c-2.6 0-4.6-2.1-4.6-4.6V15.7c0-2.5 2.1-4.6 4.6-4.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "SI_4L_fill_green",
    d: "M55.3 15.5s0-3.4-2-5.3c-2-2.5-5.3-2.5-5.3-2.5H36.1c-.4 0-.5-.5-.3-.7l2.7-2.2c.3-.2.6-.3.9-.3h9.3c5.7 0 9.9 4.9 9.9 9.9v14.5c0 .3-.1.7-.3.9l-2.4 2.8c-.2.3-.7.1-.7-.3l.1-16.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "SI_4L_stroke",
    d: "M41.3 11.1v5.6M47.3 11.1v5.6M35.3 11.1v5.6"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "SI_4L_stroke",
    cx: 35.3,
    cy: 17.9,
    r: 0.9
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "SI_4L_stroke",
    cx: 41.2,
    cy: 17.9,
    r: 0.9
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "SI_4L_stroke",
    cx: 47.3,
    cy: 17.9,
    r: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleForm);
export default __webpack_public_path__ + "static/media/doubleForm.0b7b726cc8f26a56340f6d2c9c362be7.svg";
export { ForwardRef as ReactComponent };